import { inject } from '@angular/core';
import { CanMatchFn, Router, Route } from '@angular/router';
import { PermissionsService } from '../services/security/permissions.service';
import { UserRole } from '../enums/user-role';

export const hasFboSelectedAndHasRole: CanMatchFn = (route: Route) => {
    const perms = inject(PermissionsService);
    const router = inject(Router);

    const roles = route.data?.['expectedRoles'] as UserRole[];

    // If no roles are specified permission is denied
    if (!roles || roles.length === 0) {
       return router.parseUrl('/forbidden');
    }
    
    // If roles are specified, check both FBO selection and role requirements, if All is specified permission is granted
    return (perms.isfboSelectedSnapshot && (perms.hasRoleAndFbo(roles) || roles.indexOf(UserRole.All) > -1)) ? true : router.parseUrl('/forbidden');
};
